import LeftArrow from 'assets/icons/arrow-left.svg'
import ChevronRight from 'assets/icons/chevron-right.svg'
import CloseIcon from 'assets/icons/close.svg'
import Mag from 'assets/icons/newsmode.svg'
import Run from 'assets/icons/runner.svg'
import Cart from 'assets/icons/shopping-cart.svg'
import User from 'assets/icons/user.svg'
import { styled } from 'styles/styled'
import { theme, themeUtils } from 'styles/theme'

export const Level2CategoriesContainer = styled.div`
  padding: 10px 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-content: flex-start;
  gap: 12px;
  overflow: hidden;
  box-sizing: border-box;
`

export const StyledCloseIcon = styled(CloseIcon)`
  grid-column: 3;
  place-self: end;
  cursor: pointer;
  transform: scale(1.2);
`

export const StyledCartIcon = styled(Cart)`
  margin-right: 16px;
  transform: scale(1.1);
  align-self: center;
`
export const StyledUserIcon = styled(User)`
  margin-right: 16px;
  transform: scale(1.1);
  align-self: center;
`

export const CartItemsCountChip = styled.div`
  height: 24px;
  width: 40px;
  border-radius: 11px;
  text-align: center;
  padding: 2px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: ${theme.palette.button.secondary.default};
  ${themeUtils.bodySmall}
`

export const StyledRunnerIcon = styled(Run)`
  width: 18px;
`

export const StyledChevronRight = styled(ChevronRight)`
  margin-right: 9px;
  align-self: center;
`

export const StyledLeftArrow = styled(LeftArrow)`
  align-self: center;
  cursor: pointer;
`

export const StyledMag = styled(Mag)`
  margin-right: 16px;
  align-self: center;
  transform: scale(1.1);
`
